module.exports = __webpack_public_path__ + "img/germany-other-heart-diseases-male.58d6c43a.png";